// extracted by mini-css-extract-plugin
export default {"mobileFilter":"SubcategorySelector_mobileFilter__wwQO9","fullWidth":"SubcategorySelector_fullWidth__vNt7R"};